import { apiClient } from './client'

export type AuthUser = {
  id: number
  email: string
  avatar_url: string
  nickname: string
  handle: string
  has_password: boolean
  is_google_linked: boolean
}

export type AuthResponse = {
  access: string
  refresh: string
  user: AuthUser
}

export const registerUser = (email: string, password: string, password2: string) =>
  apiClient.post<AuthResponse>('/auth/register/', { email, password, password2 })

export const loginUser = (email: string, password: string) =>
  apiClient.post<AuthResponse>('/auth/login/', { email, password })

export const loginWithGoogle = (credential: string) =>
  apiClient.post<AuthResponse>('/auth/google/', { credential })

export const refreshAccessToken = (refresh: string) =>
  apiClient.post<{ access: string }>('/auth/token/refresh/', { refresh })

export const fetchMe = () =>
  apiClient.get<AuthUser>('/users/me/')

export const updateMe = (nickname: string) =>
  apiClient.patch<AuthUser>('/users/me/', { nickname }).then((r) => r.data)

export const linkGoogle = (credential: string) =>
  apiClient.post<{ detail: string }>('/auth/link/google/', { credential })

export const unlinkGoogle = () =>
  apiClient.delete<{ detail: string }>('/auth/unlink/google/')

export const setPassword = (new_password: string, new_password2: string) =>
  apiClient.post<AuthResponse>('/auth/set-password/', { new_password, new_password2 })
